/* eslint-disable eqeqeq */
/* eslint-disable no-mixed-operators */

import React, { createContext, useContext, useEffect, useState } from 'react';
// import { useHistory } from 'react-router-dom';
// import PrimaryButton from 'components/atoms/Button';
import FormContents from 'components/atoms/Form/FormContents';
import FormPadding from 'components/atoms/Form/FormPadding';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import CalendarForm from 'components/molecules/CalendarForm';
import { Row, Col } from 'react-grid-system';
import { css } from '@emotion/core';
// import { css } from '@emotion/core';
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import BodyText from 'components/atoms/BodyText';
import BlockUI from 'components/molecules/BlockUi';
import moment from 'moment';
import {
  useStampListForm, eventScroll, downloadOriginalPDF, attendStampContext, useIntialState
} from './hooks';
import { achievementConfirmStamp, postCopyAchievement } from 'api/achievementConfirm';
import ToastModal from '../../../ToastModal';
import MonthHourTable from './MonthHourTable';
import MonthDayTable from './MonthDayTable';
import PaidHolidayGranTable from './PaidHolidayGranTable';
import SpecialHolidayGrantTable from './SpecialHolidayGrantTable';
import SubstituteHolidayTable from './SubstituteHolidayTable';
import TransferHolidayTable from './TransferHolidayTable';
import AttendStampTable from './AttendStampTable';
import AttendStampTableNoData from './AttendStampTableNoData';
import { productColor } from 'components/styles';
import FormTitle from 'components/atoms/Form/FormTitle';
import NursingCareHolidayDataTable from './NursingCareHolidayDataTable';
import NursingHolidayDataTable from './NursingHolidayDataTable';
import ClickableIconButton from 'components/atoms/ClickableIconButton';
import { exportFilePDFv2 } from 'api/attendAchievementOutput';
import useToastNotification from 'hooks/useToastNotification';
import Icon from 'components/atoms/Icon';
import SelectForm from 'components/molecules/SelectForm';

import PrimaryButton, { SecondaryButton } from "components/atoms/Button";
import Modal from "components/molecules/Modal";
import RadioSelectForm from 'components/molecules/RadioSelectForm';
import CalendarMonth from 'components/molecules/CalendarV1/CalendarMonth';
import CalendarRangeV2 from 'components/molecules/CalendarV1/CalendarRangeV2';
import FormHeader from 'components/templates/FormHeader';

const AttendStampForm: React.FC = () => {
  // const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastModalOpen, setToastModalOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmArchivementModal, setConfirmArchivementModal] = useState(false);
  const [typeConfirm, setTypeConfirm] = useState(1); //1: confirm, 2: unconfirm
  const site: string | null = sessionStorage.getItem('loginUser.site');
  const [attendHolidays, setAttendHolidays] = useState([]);
  const [subTotalTime, setSubTotalTime] = useState(Object());
  const [subTotalDay, setSubTotalDay] = useState(Object());
  const [business, setBusiness] = useState([]);
  const [term, setTerm] = useState([]);
  const [holidaySubtotalItem, setHolidaySubtotalItem] = useState([]);
  const [closingDate, setClosingDate] = useState((Number(sessionStorage.getItem('loginUser.closingDate') || 0)));
  const context = useIntialState();

  const {
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    staffCode,
    setStaffCode,
    targetMonth,
    setTargetMonth,
    orgCode,
    setOrgCode,
    selectOrgCode,
    setSelectOrgCode,
    viewPeriod,
    setViewPeriod,
    flagReLoad,
    setFlagReload,
    isReloader,
    setIsReloader,
    orgCodeList,
    setOrgCodeList
  } = context;

  const [oldOrgCode, setOldSelectOrgCode] = useState(sessionStorage.getItem('attendStampList.orgCode')! || sessionStorage.getItem('loginUser.orgCode')!);
  const [tmpStaffCode, setTmpStaffCode] = useState(sessionStorage.getItem('attendStampList.staffCode')! || sessionStorage.getItem('loginUser.staffCode')!);
  const [attendFlag] = useState(sessionStorage.getItem('attendStampList.attendFlag') || '0');
  const GMOFlag = sessionStorage.getItem('loginUser.companyCode') === 'gmohd';
  const [isSelectCalendar, setIsSelectCalendar] = useState(false);
  const [closingDateV2, setClosingDateV2] = useState(0);

  const {
    employment,
    nursingCareHolidayData,
    nursingHolidayData,
    paidHolidayGrantData,
    specialHolidayGrantList,
    staffList,
    stampBusiness,
    stampItems,
    stampTerm,
    substituteHolidayUsingStatusList,
    transferHolidayUsingStatusList,
    isConfirmError,
    setIsReload,
    isReload,
    isConfirmAchievement
  } = useStampListForm(
    closingDate,
    attendFlag,
    '',
    setSubTotalTime,
    setSubTotalDay,
    setHolidaySubtotalItem,
    setAttendHolidays,
    setIsLoading,
    setTerm,
    setBusiness,
    isSelectCalendar,
    setOldSelectOrgCode,
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    staffCode,
    setStaffCode,
    targetMonth,
    setTargetMonth,
    orgCode,
    setOrgCode,
    selectOrgCode,
    setSelectOrgCode,
    viewPeriod,
    setViewPeriod,
    flagReLoad,
    setFlagReload,
    isReloader,
    setIsReloader,
    setOrgCodeList,
    oldOrgCode
  );

  function timeDisp(time: any) {
    if (time === 0 || !time) {
      return '-';
    }
    return time;
  }

  const { errorNotification, successNotification } = useToastNotification();

  const downloadPdf = async () => {
    setIsLoading(true);
    exportFilePDFv2(
      selectOrgCode,
      moment(targetDateFrom.toString()).format('YYYY-MM-DD'),
      moment(targetDateTo.toString()).format('YYYY-MM-DD'),
      staffCode
    ).then((response: any) => {
      setIsLoading(false);
      downloadOriginalPDF(response, '勤怠実績出力.pdf');
    }).catch((error) => {
      setIsLoading(false);
      errorNotification('対象月、対象組織において在籍するスタッフがいませんでした。');
    })
  }

  function countHolidayColspan(distinctionHoliday: any, attendHolidayList: any) {
    // 法定休日 + 所定休日 or 休日
    let result = distinctionHoliday ? 2 : 1;
    // 業務数
    result += attendHolidayList ? attendHolidayList.length : 0;
    // 遅刻 + 早退
    result += 2;
    return result;
  }

  const handleCopyAchievement = () => {
    setConfirmModal(false);
    setIsLoading(true);
    const params = {
      updateUser: sessionStorage.getItem('loginUser.staffCode') || '',
      periodFrom: moment(new Date(targetDateFrom)).format('YYYY-MM-DD'),
      periodTo: moment(new Date(targetDateTo)).format('YYYY-MM-DD'),
      staffCode,
    }
    postCopyAchievement(params).then((response: any) => {
      setIsLoading(false);
      setIsReloader(true);
      if (response) {
        // setFlagReload(Number(new Date()));
        successNotification('実績が登録されました。')
      }
    }).catch((error: any) => {
      setIsLoading(false);
      if (error.response && error.response.data) {
        const errText = error.response.data.defaultMessage
        errorNotification(errText);
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
      }
    })
  }

  useEffect(() => {
  }, [nursingCareHolidayData, nursingHolidayData])

  useEffect(() => {
    if (viewPeriod !== null) {
      sessionStorage.setItem('attendStampList.viewPeriod', String(viewPeriod));
      sessionStorage.setItem('headquartersFinal.viewPeriod', '');
    }
  }, [viewPeriod])

  useEffect(() => {
    let session = sessionStorage.getItem('attendStampList.viewPeriod');
    if (session !== null) {
      setViewPeriod(session);
    } else {
      setViewPeriod('monthly');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (targetMonth !== null) {
      sessionStorage.setItem('attendStampList.targetMonth', String(targetMonth));
    }
  }, [targetMonth])

  useEffect(() => {
    let session = sessionStorage.getItem('attendStampList.targetMonth');
    if (session !== null) {
      setTargetMonth(new Date(session));
    } else {
      setTargetMonth(new Date());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (targetDateFrom !== null) {
      sessionStorage.setItem('attendStampList.targetDateFrom', String(targetDateFrom));
    }
  }, [targetDateFrom, viewPeriod])

  useEffect(() => {
    let session = sessionStorage.getItem('attendStampList.targetDateFrom');
    if (session !== null) {
      setTargetDateFrom(new Date(session));
    } else {
      setTargetDateFrom(new Date());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (targetDateTo !== null) {
      sessionStorage.setItem('attendStampList.targetDateTo', String(targetDateTo));
    }
  }, [targetDateTo])

  useEffect(() => {
    let session = sessionStorage.getItem('attendStampList.targetDateTo');
    if (session !== null) {
      setTargetDateTo(new Date(session));
    } else {
      setTargetDateTo(new Date());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleConfirmAchievement = () => {

    if (!confirmArchivementModal) {
      setConfirmArchivementModal(true);
      return false;
    }

    const param = {
      companyCode: sessionStorage.getItem('loginUser.companyCode'),
      closingDate: closingDateV2,
      employmentId: "",
      orgCode: selectOrgCode,
      searchClosingDate: closingDateV2,
      staffCode: staffCode,
      targetDateFrom: moment(targetDateFrom).format("YYYY-MM-DD"),
      targetDateTo: moment(targetDateTo).format("YYYY-MM-DD"),
    }

    if (new Date(targetDateTo).getTime() > new Date().getTime()) {
      errorNotification("対象期間は不正のため、月次提出できません。");
      setConfirmArchivementModal(false);
      return false;
    }

    setIsLoading(true);
    achievementConfirmStamp(param, typeConfirm === 1 ? 'confirm' : 'unconfirm').then((response: any) => {
      // setIsLoading(false); 
      successNotification('月次提出しました。');
      setConfirmArchivementModal(false);
      setIsReloader(true);
    }).catch((error: any) => {
      setIsLoading(false);
      setConfirmArchivementModal(false);
      const { response } = error;
      if (response.status === 400) {
        if (response.data.errors && response.data.errors.length > 0) {
          errorNotification(response.data.errors.map((x: any) => x.defaultMessage).join('<br/>'));
        } else if (response.data.defaultMessage) {
          errorNotification(response.data.defaultMessage);
        } else {
          errorNotification(response.data.message);
        }
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
      }
    });
  }

  return (
    <div>
      <BlockUI blocking={isLoading}>
      <FormHeader title="打刻データ確認" />  
      <attendStampContext.Provider value={context}>
        <FormContents customStyle={css({ marginTop: '60px' })}>
          <div className="wrap-attend-stamp-list">
            <FormPadding customStyle={css({marginTop: '8px'})}>
              <Row>
                <Col lg={2} md={2} xs={12}>
                  <div style={{ marginTop: '0px' }}>
                    <BodyText>期間</BodyText>
                  </div>
                </Col>
                <Col lg={10} md={10} xs={12}>
                  <FlexBox>
                    <Col lg={2} md={3} xs={4}>
                      <div style={{ marginTop: '-10px', marginLeft:'-2px' }}>
                        <RadioSelectForm
                          label=""
                          name="monthly"
                          items={[
                            {
                              label: '月指定',
                              value: 'monthly',
                            },
                          ]}
                          value={viewPeriod}
                          setValue={(e) => {
                            setViewPeriod(e.target.value);
                            setIsReloader(true);
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg={4} md={6} xs={8}>
                      <FlexBox customStyle={css({ marginRight: '20px' })}>
                        <FlexBoxItem>
                          <CalendarMonth
                            date={new Date(targetMonth)}
                            setDate={(date) => {
                              setTargetMonth(date);
                              if(new Date(targetMonth).getTime() !== date.getTime()) {
                                setIsReloader(true);
                              }
                            }}
                            readOnly={viewPeriod === 'daily'}
                            openActionChevron={true}
                          />
                        </FlexBoxItem>
                      </FlexBox>
                    </Col>
                  </FlexBox>
                  <FlexBox customStyle={css({ marginTop: '16px' })}>
                    <Col lg={2} md={3} xs={4}>
                      <div style={{ marginTop: '-20px', marginLeft:'-2px' }}>
                        <RadioSelectForm
                          label=""
                          name="daily"
                          items={[
                            {
                              label: '期間指定',
                              value: 'daily',
                            },
                          ]}
                          value={viewPeriod}
                          setValue={(e) => {
                            setViewPeriod(e.target.value);
                            setIsReloader(true);
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg={6} md={10} xs={8}>
                      <FlexBox>
                        <FlexBoxItem>
                          <CalendarRangeV2
                            startDate={targetDateFrom}
                            onChangeStart={(date: Date) => {
                              sessionStorage.setItem('attendStampList.targetDateFrom', String(date));
                              setTargetDateFrom(date);
                              setIsReloader(true);
                            }}
                            endDate={targetDateTo}
                            onChangeEnd={(date) => {
                              if (date) {
                                sessionStorage.setItem('attendStampList.targetDateTo', String(date));
                                setTargetDateTo(date);
                                setIsReloader(true);
                              }
                            }}
                            readOnly={viewPeriod === 'monthly'}
                          />
                        </FlexBoxItem>
                      </FlexBox>
                    </Col>
                  </FlexBox>
                </Col>
              </Row>
            </FormPadding>
            <FormPadding>
              <Row>
                <Col style={{ display: 'flex', alignItems: 'center' }} lg={2} md={3}>
                  <BodyText>組織</BodyText>
                </Col>
                <Col lg={10} md={10}>
                <FlexBox>
                    <FlexBoxItem width="480px">
                      <SelectForm
                        label=""
                        name="selectOrgCode"
                        value={selectOrgCode}
                        setValue={(v) => {
                          setStaffCode((oldOrgCode === v) ? tmpStaffCode : '');
                          setOldSelectOrgCode(selectOrgCode);
                          sessionStorage.setItem('attendStampList.orgCode', v)
                          setSelectOrgCode(v);
                          setIsReloader(true);
                        }}
                        options={orgCodeList}
                        placeholder=""
                        ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && orgCodeList.length === 1)}
                      />
                      </FlexBoxItem>
                  </FlexBox>
                </Col>
              </Row>
            </FormPadding>
            <FormPadding customStyle={css({
              height: `${staffList.length === 0 || staffCode === '' || stampItems.length === 0 ? '350px' : '32px'}`
            })}>
              <Row>
                  <Col style={{ display: 'flex', alignItems: 'center' }} lg={2} md={3}>
                    <BodyText>スタッフ</BodyText>
                  </Col>
                  <Col lg={10} md={10}>
                  <FlexBox>
                      <FlexBoxItem width="480px">
                        <SelectForm
                          label=""
                          name="staffCode"
                          value={staffCode}
                          setValue={(v) => {
                            sessionStorage.setItem('attendStampList.staffCode', v)
                            setStaffCode(v);
                            setTmpStaffCode(v);
                            setIsReloader(true);
                          }}
                          options={staffList}
                          ghost={[2, 3].includes(Number(site)) ? false : true}
                          placeholder="スタッフを選択してください"
                        />
                      </FlexBoxItem>
                    </FlexBox>
                  </Col>
                </Row>
            </FormPadding>  
           
            {staffList.length === 0 || staffCode === '' || stampItems.length === 0 ?
              <div style={{ textAlign: 'center', fontWeight: 'normal', fontFamily: 'inherit', position: 'relative', top: '-200px' }}>
                <BodyText size="re" color='#666666' customStyle={css({})}>データはありません。</BodyText>
              </div>
              :
              <>
                <Row style={{ marginBottom: '45px' }}>
                  <Col xs={12}>
                    <div className="panel panel-default">
                      <FlexBox justifyContent="space-between" customStyle={css({ margin: '8px 10px 20px 0' })}>
                        <FormTitle title={`日別データ${Number(employment.workSystem) === 2 ? "（裁量労働のため、深夜時間は内訳表示となっています）" : ""}`} bold={true} />
                        <FlexBox>
                          {viewPeriod === 'monthly' && isConfirmError && (
                            <SecondaryButton
                              text={"提出取り下げ"}
                              customStyle={css({ marginRight: '15px' })}
                              disabled={new Date(targetDateTo).getTime() > new Date().getTime() || isConfirmAchievement}
                              onClick={() => {
                                handleConfirmAchievement();
                                setTypeConfirm(2);
                              }}
                            />
                          )}
                          {viewPeriod === 'monthly' && !isConfirmError && (
                            <PrimaryButton
                              text={"月次提出"}
                              customStyle={css({ marginRight: '15px' })}
                              disabled={new Date(targetDateTo).getTime() >= new Date(moment().format("YYYY/MM/DD")).getTime() || isConfirmAchievement}
                              onClick={() => {
                                handleConfirmAchievement();
                                setTypeConfirm(1);
                              }}
                            />
                          )}
                          {attendFlag !== '1' && (!GMOFlag || sessionStorage.getItem('loginUser.site') === '3') && (
                            <PrimaryButton
                              text="シフト→実績"
                              disabled={[2, 3].indexOf(employment.workSystem) !== -1}
                              onClick={handleCopyAchievement}
                            />
                          )}
                          {
                            staffList.length > 0 && staffCode !== '' && stampItems.length > 0 ?
                              <Col md={1}>
                                <ClickableIconButton onClick={downloadPdf} additionalCss={css({ margin: "7px 0 0 10px", cursor: "pointer" })}>
                                  <span className="print">
                                    <Icon type="printer" color="" size="24px" />
                                  </span>
                                </ClickableIconButton>
                              </Col>
                              :
                              <></>
                          }
                        </FlexBox>
                      </FlexBox>
                      <div className="panel-body">
                        <Row className="table-padding">
                          <Col xs={12}>
                            {
                              stampItems && stampItems.length && staffCode != '' ? (
                                <AttendStampTable
                                  eventScroll={eventScroll}
                                  business={stampBusiness || []}
                                  term={stampTerm}
                                  targetDateFrom={targetDateFrom}
                                  targetDateTo={targetDateTo}
                                  selectOrgCode={selectOrgCode}
                                  attendFlag={attendFlag}
                                  stampItems={stampItems}
                                  emp={employment}
                                  staffCode={staffCode}
                                  staffList={staffList}
                                  remote={employment.isRemote}
                                  viewPeriod={viewPeriod}
                                  isConfirmError={isConfirmError}
                                />
                              ) : (
                                <AttendStampTableNoData
                                  eventScroll={eventScroll}
                                  business={stampBusiness || []}
                                  term={stampTerm || []}
                                  targetDateFrom={targetDateFrom}
                                  targetDateTo={targetDateTo}
                                  selectOrgCode={selectOrgCode}
                                  attendFlag={attendFlag}
                                  stampItems={stampItems}
                                  emp={employment}
                                  staffCode={staffCode}
                                  staffList={staffList}
                                  isConfirmError={isConfirmError}
                                />
                              )
                            }
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
                <FormTitle title={`集計時間データ${Number(employment.workSystem) === 2 ? "（裁量労働のため、深夜時間は内訳表示となっています）" : ""}`} />
                  <Row className="border-left-right" style={{ margin: '0 15px 30px ', borderRadius: '3px' }}>
                    <Col xs={12}>
                      <MonthHourTable
                        employment={employment}
                        business={business || []}
                        term={term || []}
                        timeDisp={timeDisp}
                        subTotalTime={subTotalTime}
                        remote={employment.isRemote}
                      />
                    </Col>
                  </Row>
                   
                <FormTitle title="集計日数データ" />
                <Row className="border-left-right" style={{ margin: '0 15px 30px ', overflow: 'auto', borderRadius: '3px' }}>
                    <Col xs={12}>
                      <MonthDayTable
                        subTotalDay={subTotalDay}
                        holidaySubtotalItem={holidaySubtotalItem}
                        countHolidayColspan={countHolidayColspan}
                        remote={employment.isRemote}
                      />
                    </Col>
                  </Row>
                {
                  (employment.autoPaidManageFunc && attendFlag === '0') ? (
                    <div>
                      <FormTitle title="有給使用状況 (現時点)" />
                      <Row className="border-left-right" style={{ margin: '0 15px 30px ', overflow: 'auto', borderRadius: '3px' }}>
                      <Col xs={12}>
                        <Col xs={12}>
                          <PaidHolidayGranTable
                            paidHolidayGrantData={paidHolidayGrantData}
                          />
                        </Col>
                      </Col>
                    </Row>
                    </div>
                   
                  ) : ''
                }
                {
                  specialHolidayGrantList.length > 0 && attendFlag === '0' && (
                    <div>
                      <FormTitle  title="特休使用状況" />
                      <Row className="border-left-right" style={{ margin: '0 15px 30px ', overflow: 'auto', borderRadius: '3px' }}>
                        <Col xs={12}>
                          <SpecialHolidayGrantTable
                            specialHolidayGrantList={specialHolidayGrantList}
                          />
                        </Col>
                      </Row>
                    </div>
                  )
                }
                {
                  substituteHolidayUsingStatusList.length > 0 && attendFlag === '0' && (
                    <div>
                      <FormTitle title="代休使用状況" />
                      <Row className="border-left-right" style={{ margin: '0 15px 30px ', overflow: 'auto', borderRadius: '3px' }}>
                        <Col xs={12}>
                          <SubstituteHolidayTable substituteHolidayUsingStatusList={substituteHolidayUsingStatusList} />
                        </Col>
                      </Row>
                    </div>
                  )
                }
                {
                  employment.useTransferApplication && transferHolidayUsingStatusList.length > 0 && attendFlag === '0' ? (
                    <div>
                      <FormTitle  title="振替状況" />
                      <Row className="border-left-right" style={{ margin: '0 15px 30px ', overflow: 'auto', borderRadius: '3px' }}>
                        <Col xs={12}>
                          <TransferHolidayTable transferHolidayUsingStatusList={transferHolidayUsingStatusList} />
                        </Col>
                      </Row>
                    </div>
                  ) : ''
                }
                {
                  nursingHolidayData && Object.keys(nursingHolidayData).length > 0 && attendFlag === '0' ? (
                    <div>
                      <FormTitle title="介護休暇使用状況" />
                      <Row className="border-left-right" style={{ margin: '0 15px 30px ', overflow: 'auto', borderRadius: '3px' }}>
                        <Col xs={12}>
                          <NursingHolidayDataTable nursingHolidayData={nursingHolidayData} />
                        </Col>
                      </Row>
                    </div>
                  ) : ''
                }
                {
                  nursingCareHolidayData && Object.keys(nursingCareHolidayData).length > 0 && attendFlag === '0' ? (
                    <div >
                      <FormTitle title="看護休暇使用状況" />
                      <Row className="border-left-right" style={{ margin: '0 15px 30px ', overflow: 'auto', borderRadius: '3px' }}>
                        <Col xs={12}>
                          <NursingCareHolidayDataTable nursingCareHolidayData={nursingCareHolidayData} />
                        </Col>
                      </Row>
                    </div>
                  ) : ''
                }
              </>
            }

            {/* <Container>
            <Row>
              <FlexBox alignItems="center" customStyle={css({ width: '100%', justifyContent: 'center', marginTop: '20px' })}>
                <FlexBoxItem>
                  <PrimaryButton
                    onClick={() => history.push(sessionStorage.getItem('headquartersFinal.monthlyList.returnDestination')! || '')}
                    ghost={false}
                    text="戻る"
                  />
                </FlexBoxItem>
              </FlexBox>
            </Row>
          </Container> */}
            <ToastModal
              open={toastModalOpen}
              closeHandler={() => setToastModalOpen(false)}
              title={toastMessage}
            />
            <Modal
              open={confirmModal}
              closeHandler={() => setConfirmModal(false)}
              title="シフトから実績を作成"
              submitText="作成する"
              note="シフトから実績を作成します。よろしいですか？"
              onSubmit={() => {
                handleCopyAchievement();
              }}
            >
              <FlexBox customStyle={css({
                color: productColor.deleteAction,
                textAlign: 'center',
                justifyContent: 'center',
                marginTop: '15px',
                fontSize: '14px'
              })}>
                ※実績の登録がないの日のみ作成します。<br />
                ※すでに実績が登録されている日は、<br />
                実績の変更はおこないません。
              </FlexBox>
            </Modal>

            <Modal
              open={confirmArchivementModal}
              closeHandler={() => setConfirmArchivementModal(false)}
              title={!isConfirmError ? "実績提出の確認" : "提出取り下げの確認"}
              submitText={!isConfirmError ? "月次提出" : "提出取り下げ"}
              note={!isConfirmError ? "実績を提出します。よろしいでしょうか？" : "提出を取り下げます。よろしいでしょうか？"}
              onSubmit={() => {
                handleConfirmAchievement();
              }}
            />
          </div>
        </FormContents>
      </attendStampContext.Provider>
      </BlockUI>
    </div>
  
  );
};

export default AttendStampForm;
